// config
import { config } from '@shakkerai/config';

/**
 * get url
 * @param {*} url
 * @returns
 */
export const getUrl = (url = '') => {
  const reqUrl = url.startsWith('http') ? url : config.apiHost + url;

  return reqUrl;
};

/**
 * 解密token
 * @param {string} token
 * @param {string} expiration
 * @returns
 */
export const obsuscator = (token, expiration) => {
  let result = token.split('');
  const [date, time] = expiration.slice(0, expiration.length - 1).split('T');
  const [h, m, s] = time.split(':');
  const [d, mon] = date.split('-').reverse();
  // 分/秒位置互换
  if (!(Number(m) === 0) && !(Number(s) === 0)) {
    const mi = Number(m) === 0 ? 0 : Number(m) * 10 - 1;
    const si = Number(s) === 0 ? 0 : Number(s) * 10 - 1;
    const pm = result[mi];
    const ps = result[si];
    result[mi] = ps;
    result[si] = pm;
  }

  // 月/日位置互换
  if (!(Number(mon) === 0) && !(Number(d) === 0)) {
    const moni = Number(mon) === 0 ? 0 : Number(mon) * 10 - 1;
    const di = Number(d) === 0 ? 0 : Number(d) * 10 - 1;
    const pmon = result[moni];
    const pd = result[di];
    result[moni] = pd;
    result[di] = pmon;
  }

  // 时位数左移
  if (Number(h) === 0) {
    return result.join('');
  }

  const rest = result.splice(-Number(h));
  result = [...rest, ...result].join('');
  return result;
};

export const isXingliu = config.env === 'aliyun';
